import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import VehicleDetail from "@/pages/VehicleDetail";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Veicoli from "@/pages/Veicoli";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminVehicleForm from "@/pages/admin/AdminVehicleForm";
import AdminMessages from "@/pages/admin/AdminMessages";
import ProtectedRoute from "@/components/ProtectedRoute";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "sonner";
import { useLocation } from "react-router-dom";

function PublicChrome() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return (
    <>
      <WhatsAppButton />
      <CookieBanner />
    </>
  );
}

function App() {
  return (
    <div className="App bg-white min-h-screen text-[#1c1f1a]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/veicoli" element={<Veicoli />} />
          <Route path="/vehicle/:id" element={<VehicleDetail />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/vehicle/new" element={<ProtectedRoute><AdminVehicleForm /></ProtectedRoute>} />
          <Route path="/admin/vehicle/edit/:id" element={<ProtectedRoute><AdminVehicleForm /></ProtectedRoute>} />
          <Route path="/admin/messages" element={<ProtectedRoute><AdminMessages /></ProtectedRoute>} />
        </Routes>
        <PublicChrome />
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(255,255,255,0.95)",
            border: "1px solid rgba(90,181,0,0.3)",
            color: "#1c1f1a",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
}

export default App;
